import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import {Observable} from 'rxjs';
import {JsonClientService} from '../../../shared/json-client';


@Injectable()
export class ConditionDeveloperListResolve {

  constructor(public jsonRpc: JsonClientService) {
  }

  private filter_columns =
    [
      'developer_caption',
      'complex_caption',
    ];

  resolve(route: ActivatedRouteSnapshot): Observable<any> | Promise<any> | any {

    const prepared_filter = {};
    const prepared_filter_keys = this.filter_columns.filter(x => !!route.parent.queryParams[x]);
    const sort = {};

    prepared_filter_keys.forEach(x => prepared_filter[x] = route.parent.queryParams[x]);

    if (!!route.queryParams['sort_name']) {
      sort[route.queryParams['sort_name']] = route.queryParams['sort_key'] || 'asc';
    }
    const options = {
      'limit': 500,
      'offset': (+(route.queryParams['page'] || 1) - 1) * 500,
      'filter': {
        'global_search_string': route.queryParams['global_search_string'] || null,
        'fields': prepared_filter,
      },
      'sort': sort
    };

    return this.jsonRpc.post('Condition.get_developer', options);
  }

}


@Injectable()
export class ConditionDeveloperSummaryResolve {

  constructor(public jsonRpc: JsonClientService) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<any> | Promise<any> | any {

    return this.jsonRpc.post('Condition.get_developer_summary');
  }

}
